
import React from "react";
import { Button } from "@/components/ui/button";

interface EmptyStateProps {
  searchTerm: string;
  setSearchTerm: (term: string) => void;
  setActiveCategory: (category: undefined) => void;
  setCityFilter: (city: undefined) => void;
  setRegionFilter: (region: undefined) => void;
}

const EmptyState: React.FC<EmptyStateProps> = ({
  searchTerm,
  setSearchTerm,
  setActiveCategory,
  setCityFilter,
  setRegionFilter,
}) => {
  return (
    <div className="text-center py-12 bg-white rounded-lg shadow">
      <p className="text-xl text-muted-foreground">No businesses found matching your criteria.</p>
      <Button 
        onClick={() => {
          setSearchTerm("");
          setActiveCategory(undefined);
          setCityFilter(undefined);
          setRegionFilter(undefined);
        }}
        className="mt-4 bg-eco-500 hover:bg-eco-600"
      >
        Clear All Filters
      </Button>
    </div>
  );
};

export default EmptyState;
